import React, { createContext, useState, useContext } from "react";

const DownloadModalContext = createContext();
export const useDownloadModal = () => useContext(DownloadModalContext);

export function DownloadModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [progress, setProgress] = useState(0);

  return (
    <DownloadModalContext.Provider
      value={{
        isOpen,
        progress,
        setIsOpen,
        setProgress,
      }}
    >
      {children}
    </DownloadModalContext.Provider>
  );
}
